import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'agb',
    loadComponent: () =>
      import('./pages/generic/terms-of-use-page/terms-of-use-page.component').then(
        (m) => m.TermsOfUsePageComponent,
      ),
  },
  {
    path: 'datenschutz',
    loadComponent: () =>
      import('./pages/generic/data-protection-notice-page/data-protection-notice-page.component').then(
        (m) => m.DataProtectionNoticePageComponent,
      ),
  },
  {
    path: 'faq',
    loadComponent: () =>
      import(
        './pages/frequently-asked-questions-page/frequently-asked-questions-page.component'
      ).then((m) => m.FrequentlyAskedQuestionsPageComponent),
  },
  {
    path: '',
    redirectTo: 'europace/unterlagenauswahl',
    pathMatch: 'full',
  },
  {
    path: ':subFolder',
    children: [
      {
        path: 'unterlagenauswahl',
        loadComponent: () => 
          import('./pages/home-page/home-page.component').then(
            (m) => m.HomePageComponent,
          ),
      },
      {
        path: 'vollmacht',
        loadComponent: () =>
          import(
            './pages/power-of-attorney-page/power-of-attorney-page.component'
          ).then((m) => m.PowerOfAttorneyPageComponent),
      },
      {
        path: 'dateneingabe',
        loadComponent: () =>
          import('./pages/data-entry-page/data-entry-page.component').then(
            (m) => m.DataEntryPageComponent,
          ),
      },
      {
        path: 'zahlung',
        loadComponent: () =>
          import('./pages/checkout-page/checkout-page.component').then(
            (m) => m.CheckoutPageComponent,
          ),
      },
      {
        path: 'bestaetigung',
        loadComponent: () =>
          import('./pages/confirmation-page/confirmation-page.component').then(
            (m) => m.ConfirmationPageComponent,
          ),
      },
      {
        path: 'lieferstatus',
        loadComponent: () =>
          import('./pages/order-status-page/order-status-page.component').then(
            (m) => m.OrderStatusPageComponent,
          ),
      },
      {
        path: 'faq',
        loadComponent: () =>
          import(
            './pages/frequently-asked-questions-page/frequently-asked-questions-page.component'
          ).then((m) => m.FrequentlyAskedQuestionsPageComponent),
      },
      {
        path: 'error',
        loadComponent: () =>
          import('./pages/generic/error-page/error-page.component').then(
            (m) => m.ErrorPageComponent,
          ),
      },
    ],
  },
];

export type RoutePaths = (typeof routes)[number]['path'];
